import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 10,
  y: 4,
  width: 2,
  height: 14
});

var SvgPlus = function SvgPlus(props) {
  return _ref;
};

export default SvgPlus;